module.exports = __webpack_public_path__ + "img/43a98d3.svg";